import { AnalyticsService } from './../../services/analytics/analytics.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { USER_ID_KEY } from '@web-frontend/shared/constants';
import { AuthService } from '@web-frontend/shared/services';
import { StorageService } from '@web-frontend/shared/services/storage/storage.service';
import {
  InstallationStateService,
  UserInstallationState,
} from '@web-frontend/shared/services/installation-state/installation-state.service';
import { PlatformService } from '@web-frontend/shared/components/platform-disable-content/platform.service';
import { authRoutes } from '../../../core/auth/auth-routing.module';
import AmplitudeEvents from '../../../../types/amplitude.enum';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private analyticsService: AnalyticsService,
    private installationStateService: InstallationStateService,
    private platformService: PlatformService
  ) {}

  public async canActivate(): Promise<boolean> {
    const keepOnboarding = localStorage.getItem('register');
    if (keepOnboarding) {
      localStorage.removeItem('register');
    }

    const userIdKey = StorageService.GetItem(USER_ID_KEY);

    // Handle mobile app scenarios
    if (this.platformService.isNative()) {
      return this.handleMobileAppAuth();
    }

    // Web logic
    if (!userIdKey) {
      this.authService.logout();
      this.router.navigateByUrl(authRoutes.login);
      return false;
    }
    return this.handleAuthenticatedUser();
  }

  private async handleMobileAppAuth(): Promise<boolean> {
    const installationState = await this.installationStateService.getUserInstallationState();

    if (
      installationState === UserInstallationState.RETURNING_USER_WITH_SESSION
    ) {
      return this.handleAuthenticatedUser();
    }

    this.router.navigateByUrl(authRoutes.login);
    return false;
  }

  private handleAuthenticatedUser(): boolean {
    const user = this.authService.user;
    if (user && user.deleted) {
      this.authService.logout();
      this.router.navigateByUrl(authRoutes.login);
      return false;
    }

    this.analyticsService.trackEvent({
      sources: ['amplitude'],
      eventName: AmplitudeEvents.page_event,
      eventProperties: { page: this.router.url },
    });

    return true;
  }
}
